import React, { useMemo } from "react";
import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import lily from "../../static/media/Home/lily.webp";
import fisio from "../../static/media/Home/fisio.webp";
import inari from "../../static/media/Home/inari.webp";
import dr from "../../static/media/Home/dr.webp";
import corsano from "../../static/media/Home/corsano.webp";

export default function StrategicPartnersSection() {
  const partners = useMemo(
    () => [
      {
        name: "Lily Sunflowers",
        img: lily,
        link: "https://www.lilysunflowers.com/",
        benefit:
          "Tratamientos faciales, corporales, mesoterapia, peluquería y depilación profesional con protocolos personalizados y enfoque estético integral.",
      },
      {
        name: "FisioHeart",
        img: fisio,
        link: "https://www.instagram.com/fisioheart.ec?igsh=MTE0MjdlYmZwYnBpbw%3D%3D",
        benefit:
          "Consulta inicial sin costo y acceso preferencial a terapias de rehabilitación física orientadas a recuperación, movilidad y bienestar funcional.",
      },
      {
        name: "Inari Sushi",
        img: inari,
        link: "https://www.instagram.com/inarisushiec?igsh=MTVwZ3h0ZWt1azkzNg%3D%3D",
        benefit:
          "Beneficios exclusivos en platos de su carta para complementar tu estilo de vida saludable con opciones frescas y de alta calidad.",
      },
      {
        name: "DR Soluciones Informáticas",
        img: dr,
        link: "https://drsolucionesinformaticas.com/",
        benefit:
          "Acceso preferencial a soporte técnico, mantenimiento de equipos, soluciones digitales empresariales y sistemas tecnológicos especializados.",
      },
      {
        name: "Centro Médico CORSANO",
        img: corsano,
        link: "https://www.instagram.com/dr.joseadames?igsh=MTdiZm94aGJtNXllbQ==",
        benefit:
          "15% de descuento en consulta cardiológica, electrocardiograma, ecocardiograma, Holter EKG, MAPA y ergometría para miembros NovaXFit.",
      },
    ],
    []
  );

  return (
    <Box
      component="section"
      aria-label="Alianzas estratégicas NovaXFit"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: "#ffffff",
        color: "#111111",
      }}
    >
      <Container maxWidth="lg">
        <Stack
          spacing={{ xs: 3, md: 4 }}
          alignItems="center"
          textAlign="center"
        >
          <Typography
            component="h2"
            sx={{
              fontSize: {
                xs: "clamp(34px, 10vw, 54px)",
                md: "clamp(62px, 4vw, 110px)",
              },
              lineHeight: { xs: 0.95, md: 0.9 },
              letterSpacing: { xs: -1.6, md: -3.2 },
              fontWeight: 800,
              textTransform: "uppercase",
            }}
          >
            Alianzas con
            <Box
              component="span"
              sx={{
                display: "block",
                mt: { xs: 0.4, md: 0.6 },
                background:
                  "linear-gradient(180deg,#ff2a2a 0%,#e50914 40%,#b90610 70%,#ff4a4a 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              NOVAXFIT
            </Box>
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: 16, md: 19 },
              lineHeight: 1.75,
              color: "#000",
              fontWeight: 500,
              maxWidth: 780,
            }}
          >
            Ser parte de NovaXFit significa acceder a servicios aliados
            cuidadosamente seleccionados para mejorar tu salud, tu bienestar y
            tu estilo de vida dentro y fuera del entrenamiento.
          </Typography>

          <Box
            sx={{
              mt: { xs: 2, md: 3 },
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2,1fr)",
                sm: "repeat(3,1fr)",
                md: "repeat(5,1fr)",
              },
              gap: { xs: 2, md: 3 },
              width: "100%",
            }}
          >
            {partners.map((partner, i) => (
              <Box
                key={i}
                component="a"
                href={partner.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visitar aliado ${partner.name}`}
                sx={{
                  minHeight: { xs: 170, md: 210 },
                  borderRadius: 4,
                  bgcolor: "#fff",
                  border: "1px solid rgba(183,6,15,0.35)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  px: { xs: 2, md: 2.5 },
                  py: { xs: 2, md: 2.5 },
                  textDecoration: "none",
                  transition:
                    "transform .22s ease, box-shadow .22s ease",
                  boxShadow: "0 14px 30px rgba(229,9,20,0.14)",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow:
                      "0 18px 34px rgba(229,9,20,0.22)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={partner.img}
                  alt={`Logo aliado ${partner.name}`}
                  loading="lazy"
                  sx={{
                    width: { xs: 85, md: 150 },
                    height: "auto",
                    objectFit: "contain",
                    mb: 1.2,
                  }}
                />

                <Typography
                  sx={{
                    fontSize: { xs: 12.8, md: 13.8 },
                    fontWeight: 500,
                    color: "#000",
                    textAlign: "center",
                    maxWidth: 180,
                    lineHeight: 1.5,
                  }}
                >
                  {partner.benefit}
                </Typography>
              </Box>
            ))}
          </Box>

          <Typography
            sx={{
              fontSize: { xs: 15.5, md: 17 },
              lineHeight: 1.7,
              color: "#000",
              fontWeight: 500,
              maxWidth: 720,
              mt: { xs: 2, md: 3 },
            }}
          >
            Explora todos los beneficios disponibles dentro de nuestra red de aliados.
          </Typography>

          <Button
            component={RouterLink}
            to="/nuestros-aliados"
            aria-label="Ver todos los aliados estratégicos NovaXFit"
            sx={{
              textTransform: "none",
              fontWeight: 700,
              borderRadius: "14px",
              py: 1.1,
              px: 3,
              fontSize: 15,
              color: "#fff",
              background:
                "linear-gradient(135deg,#5f0008 0%,#a80d19 40%,#df2632 70%,#161616 100%)",
              boxShadow: "0 12px 35px rgba(229,9,20,0.25)",
              "&:hover": {
                filter: "brightness(1.05)",
              },
            }}
          >
            Descubre tus beneficios exclusivos
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}